import clsx from 'clsx';
import { FC, ReactNode } from 'react';

interface ModalCompModel {
  children: ReactNode;
  toggleModal: () => void;
  title?: string;
  width?: string;
  hideClose?: boolean;
}

const ModalComp: FC<ModalCompModel> = ({
  children,
  title,
  width = 'w-full',
  toggleModal,
  hideClose = false,
}) => {
  return (
    <div>
      <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto overflow-x-hidden outline-none focus:outline-none">
        <div className="relative my-6 mx-auto w-4/5 max-w-3xl">
          {/*content*/}
          <div
            className={clsx(
              'relative mx-auto flex flex-col rounded-lg border-0 bg-white py-6 px-2 shadow-lg outline-none focus:outline-none',
              width
            )}
          >
            {!hideClose && (
              <p className="flex justify-end rounded-md p-5 py-1">
                <span
                  className="cursor-pointer text-center text-red-500"
                  onClick={toggleModal}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                </span>
              </p>
            )}
            {/*header*/}
            {title && <h2 className="my-2 text-center text-2xl">{title}</h2>}
            {children}
          </div>
        </div>
      </div>
      <div className="fixed inset-0 z-40 bg-black opacity-25"></div>
    </div>
  );
};

export default ModalComp;
